import {
  BugIcon,
  CircleIcon,
  EmptyState,
  GitMergeIcon,
  Mtds,
  NewsImage,
  MarkdownContent,
  ScreenHeader,
  Timeline,
  toLocaleDateString,
  useGetNewsArticlesQuery
} from 'prove-common'
import { AppLayout } from '../../components/app-layout/AppLayout'

type NewsListScreenProps = {
  topBar?: React.ReactNode
  sidebar?: React.ReactNode
  useMobileBar?: boolean
}

export const NewsListScreen = ({
  topBar,
  sidebar,
  useMobileBar
}: NewsListScreenProps) => {
  const { data: articles, isLoading, isError } = useGetNewsArticlesQuery()

  const formatAppName = (appName: string) => {
    if (appName === 'ProveTa') return 'Prøveta'
    if (appName === 'ProvePlan') return 'Prøveplan'
    return appName
  }

  const formatIcon = (icon: string): React.ReactNode => {
    if (icon === 'merge') return <GitMergeIcon />
    if (icon === 'bug') return <BugIcon />
    return <CircleIcon />
  }

  return (
    <AppLayout
      sidebar={sidebar}
      topBar={topBar}
      useMobileBar={useMobileBar}
      isLoading={isLoading}
      isError={isError}
    >
      <ScreenHeader
        title='Nyheter'
        description={
          <p>
            Her kan du se nyheter som har blitt delt tidligere. Du får dermed en
            komplett oversikt over alle nye funksjoner og fikser som vi setter i
            produksjon på Prøveta og Prøveplan.
          </p>
        }
      />
      <div>
        {articles == null || articles.length === 0 ? (
          <EmptyState
            title='Ingen nyheter'
            description='Det finnes ingen nyheter å vise.'
          />
        ) : (
          [...articles].reverse().map((article, index) => (
            <div
              key={article.id}
              className='flex justify-stretch'
              data-color={article.icon == 'merge' ? 'success' : 'danger'}
            >
              <Timeline
                showLine={index !== articles.length - 1}
                icon={formatIcon(article.icon)}
              />
              <div className='lg:ml-16 ml-4 mb-20 lg:w-[666px] lg:flex lg:justify-between grow'>
                <div>
                  <Mtds.Tag data-color='neutral' data-icon='none'>
                    <Mtds.Flex data-align='center'>
                      <strong>{formatAppName(article.app)}</strong>
                      <Mtds.Muted>
                        {toLocaleDateString(article.date)}
                      </Mtds.Muted>
                    </Mtds.Flex>
                  </Mtds.Tag>
                  <MarkdownContent content={article.subject} />
                </div>
                <NewsImage
                  className='w-64 h-auto rounded-sm object-contain '
                  articleId={article.id}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </AppLayout>
  )
}
